module.exports = __webpack_public_path__ + "static/media/hero_rendering.d474262d.jpg";